import "./bootstrap";
import "../css/app.css";
import React from "react";
import { hydrateRoot } from "react-dom/client";
import { createInertiaApp, router } from "@inertiajs/react";
import { resolvePageComponent } from "laravel-vite-plugin/inertia-helpers";
import { ErrorBoundary } from "@/Components/ErrorBoundary";
import { Wrapper } from "@/AppWrapper.tsx";

const appName =
    window.document.getElementsByTagName("title")[0]?.innerText ||
    "SCDS Membership";

createInertiaApp({
    progress: {
        color: "#4F46E5",
    },
    title: (title) => `${title} - ${appName}`,
    resolve: (name) =>
        Promise.any([
            resolvePageComponent(
                `./Pages/${name}.jsx`,
                import.meta.glob("./Pages/**/*.jsx"),
            ),
            resolvePageComponent(
                `./Pages/${name}.tsx`,
                import.meta.glob("./Pages/**/*.tsx"),
            ),
        ]),
    setup({ el, App, props }) {
        router.on("before", (event) => {
            event.detail.visit.headers["X-Inertia-Prefetch"] = event.detail
                .visit.prefetch
                ? "true"
                : "false";
        });

        hydrateRoot(
            el,
            <ErrorBoundary>
                <Wrapper>
                    <App {...props} />
                </Wrapper>
            </ErrorBoundary>,
        );
    },
});
